import React, { useEffect } from 'react';
import moment from 'moment-timezone';
import { get } from 'lodash';
import { useDispatch, useSelector } from 'react-redux';
import { TEMP_DASHBOARD_URL, DASHBOARD_TYPE } from '@utils/constants';
import { useLocationQuery } from '@src/hooks';
import { Loading, PageNotFound } from '@components/common';
import { createTempDashboard } from '@store/tempDashboard/actions';
import { dashboardsSelector } from '@store/tempDashboard/selectors';
import useFetchEvent from './useFetchEvent';
import { useNavigate } from 'react-router-dom';

export const PreManualAlertDiagnostics = () => {
  const dispatch = useDispatch();
  const dashboards = useSelector(dashboardsSelector);
  const query = useLocationQuery();
  const navigate = useNavigate();
  const e = query.get('event');
  const eventId = e ? parseInt(e, 10) : null;
  const { isFetching: loading, data: event } = useFetchEvent({ eventId });

  if (!e) {
    return <PageNotFound />;
  }

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    if (!event || loading) {
      return;
    }

    for (const dashboardID of Object.keys(dashboards)) {
      const dashboard = dashboards[dashboardID];
      if (
        dashboard.type === DASHBOARD_TYPE.ALERT_DIAGNOSTICS &&
        get(dashboard, 'dashboard.module:trends.alerts.selectedEvent.id', null) === eventId
      ) {
        navigate(`${TEMP_DASHBOARD_URL[DASHBOARD_TYPE.ALERT_DIAGNOSTICS]}${dashboardID}`);
        return;
      }
    }

    const alertName = get(event, 'alert.name');
    const { id, name, rule, isAdvanced } = get(event, 'alert.filter');
    const appliedFilter = {
      fid: id,
      name,
      rule,
      isAdvanced,
    };

    const preferEndTime = moment(event.time).add(3, 'hour');
    const now = moment();
    const endTime = (now.isAfter(preferEndTime) ? preferEndTime : now).startOf('minute');

    const interval = {
      from: moment(endTime).subtract(6, 'hours'),
      to: endTime,
    };

    const dashboard = {
      common: {
        appliedFilters: [appliedFilter],
        interval,
      },
      ['module:trends']: {
        alerts: {
          selectedEvent: event,
        },
      },
    };

    dispatch(
      createTempDashboard(DASHBOARD_TYPE.ALERT_DIAGNOSTICS, dashboard, `Alert: ${alertName}`),
    );
  }, [event, loading]);

  if (loading) {
    return <Loading />;
  } else if (!event) {
    return <PageNotFound />;
  }

  return null;
};
